import { render, staticRenderFns } from "./SurgeryDetails.vue?vue&type=template&id=6595fb64"
import script from "./SurgeryDetails.vue?vue&type=script&lang=js"
export * from "./SurgeryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports